import moment from 'moment';

/** Days a delivered report / update remains valid after its closing date. */
export const UPDATE_VALIDITY_DAYS = 29;

export const formatVersionDate = value =>
  value && moment(value).isValid() ? moment(value).format('MM/DD/YYYY') : 'N/A';

export const getValidThrough = closingDate => {
  const closingAt = closingDate ? moment(closingDate) : null;
  return closingAt?.isValid() ? closingAt.clone().add(UPDATE_VALIDITY_DAYS, 'days') : null;
};

export const isValidThroughExpired = validThrough =>
  Boolean(validThrough?.isValid() && moment().isAfter(validThrough, 'day'));

/** Pill / status meta: delivered vs requested date label. */
export const getVersionDeliveryMeta = version => {
  const isDelivered = Boolean(version?.deliveredAt);
  const rawDate = isDelivered ? version.deliveredAt : version?.createdAt;
  const date = formatVersionDate(rawDate);
  return {
    isDelivered,
    date,
    label: isDelivered ? `Delivered ${date}` : `Requested ${date}`
  };
};

export const getLatestUpdateVersion = (versions = []) =>
  versions
    .filter(v => (v.versionNumber || 0) > 1)
    .reduce(
      (latest, version) =>
        !latest || (version.versionNumber || 0) > (latest.versionNumber || 0) ? version : latest,
      null
    );

/** True when the latest update was created within the validity window. */
export const wasUpdatedWithinValidityWindow = (versions = []) => {
  const latestUpdate = getLatestUpdateVersion(versions);
  const recentDate = latestUpdate?.createdAt || latestUpdate?.deliveredAt;
  const recentMoment = recentDate ? moment(recentDate) : null;
  if (!recentMoment?.isValid()) return { showWarning: false, recentMoment: null };

  const daysSinceUpdate = moment().diff(recentMoment, 'days');
  return {
    showWarning: daysSinceUpdate >= 0 && daysSinceUpdate <= UPDATE_VALIDITY_DAYS,
    recentMoment
  };
};

export const getNextUpdateNumber = (versions = []) =>
  versions.filter(v => (v.versionNumber ?? v.version_number ?? 0) > 1).length + 1;

export const getLatestVersion = (versions = []) => {
  if (!versions.length) return null;
  return versions.reduce((a, b) => ((a.versionNumber || 0) > (b.versionNumber || 0) ? a : b));
};

export const needsVersionDeliveredDate = (versions = []) => {
  const latest = getLatestVersion(versions);
  return Boolean(latest && !latest.deliveredAt);
};
